import React from 'react';
import { HoverBadges } from './HoverBadges';
import EditButton from 'components/v2/buttons/EditButton';

function ShipmentLegs({ value, node, column, api }) {
  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    api.startEditingCell({
      rowIndex: node.rowIndex,
      colKey: column.getId(),
    });
  };
  return (
    <div className="flex justify-between">
      <HoverBadges value={value} />
      <EditButton
        className="flex-shrink-0 flex-grow-0"
        size="small"
        onClick={handleClick}
      />
    </div>
  );
}

export default ShipmentLegs;
